import React, { useState } from 'react';
import { ITEMSDETAILS } from 'src/pages/equity/components/common/constants';
import { useDispatch } from 'react-redux';
import { setImplantableAndInstrumentProducts } from 'src/pages/scheduleSurgery/redux/actions';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line camelcase
import { generate_UUID } from 'src/utils/util';
import MainContainerView from './MainContainer/MainContainerView';
import ListViewCards from './ListViewCards/ListViewCards';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ListViewContainer = ({
    products = [],
    setsQuantityCheck = () => {},
    removeCount = () => {},
    addCount = () => {},
    handleSetItemClick = () => {},
    deleteProduct = () => {},
    isShippingScreen = false,
    isReviewSubmitScreen = false,
    inventoryShipping = false,
    handleLocationChange = () => {},
    checkAll = false,
    checked,
    checkSelectAllDisabled = () => {},
    selectAllDisabled = '',
    handleShipAllChange = () => {},
    selectedLocation,
    isBatchSelected = false,
    setIsBatchSelected = () => {},
    setsQuantityCount,
    itemsQuantityCount,
    overridenDiscount,
    nonTissueSummary,
    tissueSummary,
    isCartScreen = false,
    isTemplateScreen = false,
    handleCheckBoxSelection = () => {},
    isOrderScreen = false,
    isOrderScreenListView = false,
    moreTemplates = false,
    isEquityTemplate = false,
    isConsignmentAdd = false,
    isEquityScreen = false,
    isEquityPage,
    isReviewSubmitScreenEquity,
    isCondensedView,
    isIndependentProductGuide = false,
    onBomClick = () => {},
    showDontShip = true,
    isConsignmnetAdd,
    isFromTemplates = false,
    isFromConsignmentAdd,
    isSurgery,
    isorderViewList = false,
    handleBundlePopup = () => {},
    handleBundleSetItemClick = () => {},
    implantShipAll,
    instrumentShipAll,
    isTemplateDetail = false,
    updateProductQuantity = () => {},
    onEmptyCategory,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [sets, setSets] = useState([]);
    const [items, setItems] = useState([]);
    const [fees, setFees] = useState([]);
    const [setImplant, setSetImplant] = useState([]);
    const [setInstrument, setSetInstrument] = useState([]);
    const [itemImplant, setItemImplant] = useState([]);
    const [itemBundles, setItemBundleList] = useState([]);
    const [itemInstrument, setItemInstrument] = useState([]);
    const [feesImplant, setFeesImplant] = useState([]);
    const [feesInstrument, setFeesInstrument] = useState([]);
    const [expandedCard, setExpandedCard] = useState({
        sets: true,
        items: true,
        fees: true,
    });

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    useEffectWithErrorLogging(() => {
        if (isOrderScreenListView) {
            let setImplantList = [];
            let setInstrumentList = [];
            let items = [...products];
            setSets(items);
            items?.map((i) => {
                if (i.isSet) {
                    i?.productMoreDetails?.billOfMaterials?.map((d) => {
                        if (d.isImplantable) {
                            setImplantList.push(d);
                        } else if (d.isInstrument) {
                            setInstrumentList.push(d);
                        }
                    });
                } else {
                    if (i.implantable) {
                        setImplantList.push(i);
                    } else if (i.instrument) {
                        setInstrumentList.push(i);
                    }
                }
            });
            setImplantList = setImplantList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    ...i,
                };
            });
            setInstrumentList = setInstrumentList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    ...i,
                };
            });
            setImplantList =
                isCartScreen ||
                isTemplateScreen ||
                isShippingScreen ||
                isReviewSubmitScreen ||
                isIndependentProductGuide
                    ? setImplantList
                    : Object.values(
                          setImplantList?.reduce((acc, curr) => {
                              const productKey =
                                  (curr.productCFN || '') +
                                  '::' +
                                  (curr.salesOrg || '');
                              if (!acc[productKey]) {
                                  acc[productKey] = { ...curr };
                              } else {
                                  acc[productKey].quantity +=
                                      curr.quantity;
                              }
                              return acc;
                          }, {})
                      );
            setInstrumentList =
                isCartScreen ||
                isTemplateScreen ||
                isShippingScreen ||
                isReviewSubmitScreen ||
                isIndependentProductGuide
                    ? setInstrumentList
                    : Object.values(
                          setInstrumentList?.reduce((acc, curr) => {
                              const productKey =
                                  (curr.productCFN || '') +
                                  '::' +
                                  (curr.salesOrg || '');
                              if (!acc[productKey]) {
                                  acc[productKey] = { ...curr };
                              } else {
                                  acc[productKey].quantity +=
                                      curr.quantity;
                              }
                              return acc;
                          }, {})
                      );
            setSetImplant(setImplantList);
            setSetInstrument(setInstrumentList);
            dispatch(
                setImplantableAndInstrumentProducts({
                    setImplantProducts: setImplantList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                    setInstrumentProducts: setInstrumentList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                })
            );
        } else {
            let setsOfList = [];
            let itemsOfList = [];
            let feesOfList = [];
            let setImplantList = [];
            let setInstrumentList = [];
            let itemImplantList = [];
            let itemInstrumentList = [];
            let itemBundle = [];
            let items = [];
            let itemBundleList = [];
            let feesImplantList = [];
            let feesInstrumentList = [];
            if (moreTemplates) {
                const removeDeletedSetProductsInEdit =
                    products?.setProducts?.filter(
                        (item) => !item.isTemplateEntryDeleted
                    );
                const removeDeletedItemProductsInEdit =
                    products?.itemProducts?.filter(
                        (item) => !item.isTemplateEntryDeleted
                    );
                const removeDeletedFeeProductsInEdit =
                    products?.feesProducts?.filter(
                        (item) => !item.isTemplateEntryDeleted
                    );
                items = isEquityTemplate
                    ? [
                          ...removeDeletedItemProductsInEdit,
                          ...removeDeletedFeeProductsInEdit,
                      ]
                    : [
                          ...removeDeletedSetProductsInEdit,
                          ...removeDeletedItemProductsInEdit,
                      ];
            } else {
                items = [...products];
            }
            items?.map((e) => {
                if (e.isSet) {
                    setsOfList.push(e);
                } else if (e.materialType == 'DIEN') {
                    feesOfList.push(e);
                } else {
                    if (
                        (e.materialType &&
                            e.materialType ==
                                ITEMSDETAILS[2].materialType['bundle']) ||
                        (Object.prototype.hasOwnProperty.call(
                            e,
                            'bundleItems'
                        ) &&
                            e.bundleItems?.length > 0)
                    ) {
                        itemBundle.push(e);
                    } else {
                        itemsOfList.push(e);
                    }
                }
            });
            setSets(setsOfList);
            setItems(itemsOfList);
            setFees(feesOfList);
            setsOfList?.map((i) => {
                if (i.implantable) {
                    setImplantList.push(i);
                } else if (i.instrument) {
                    setInstrumentList.push(i);
                }
            });
            setImplantList = setImplantList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    brand: i.brand,
                    ...i,
                };
            });
            setInstrumentList = setInstrumentList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    brand: i.brand,
                    ...i,
                };
            });
            setImplantList =
                isCartScreen ||
                isTemplateScreen ||
                isShippingScreen ||
                isReviewSubmitScreen ||
                isIndependentProductGuide ||
                isorderViewList
                    ? setImplantList
                    : Object.values(
                          setImplantList?.reduce((acc, curr) => {
                              const productKey =
                                  (curr.productCFN || '') +
                                  '::' +
                                  (curr.salesOrg || '');
                              if (!acc[productKey]) {
                                  acc[productKey] = { ...curr };
                              } else {
                                  acc[productKey].quantity +=
                                      curr.quantity;
                              }
                              return acc;
                          }, {})
                      );
            setInstrumentList =
                isCartScreen ||
                isTemplateScreen ||
                isShippingScreen ||
                isReviewSubmitScreen ||
                isIndependentProductGuide ||
                isorderViewList
                    ? setInstrumentList
                    : Object.values(
                          setInstrumentList?.reduce((acc, curr) => {
                              const productKey =
                                  (curr.productCFN || '') +
                                  '::' +
                                  (curr.salesOrg || '');
                              if (!acc[productKey]) {
                                  acc[productKey] = { ...curr };
                              } else {
                                  acc[productKey].quantity +=
                                      curr.quantity;
                              }
                              return acc;
                          }, {})
                      );
            itemsOfList?.map((i) => {
                if (i.implantable) {
                    itemImplantList.push(i);
                } else if (i.instrument) {
                    itemInstrumentList.push(i);
                } else {
                    itemInstrumentList.push(i);
                }
            });
            itemImplantList = itemImplantList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    brand: i.brand,
                    ...i,
                };
            });
            itemInstrumentList = itemInstrumentList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    brand: i.brand,
                    ...i,
                };
            });
            itemBundleList = itemBundle?.map((i) => {
                return {
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    ...i,
                };
            });
            itemImplantList = isorderViewList
                ? itemImplantList
                : Object.values(
                      itemImplantList?.reduce((acc, curr) => {
                          const productKey =
                              (curr.productCFN || '') +
                              '::' +
                              (curr.salesOrg || '');
                          if (!acc[productKey]) {
                              acc[productKey] = { ...curr };
                          } else {
                              acc[productKey].quantity += curr.quantity;
                          }
                          return acc;
                      }, {})
                  );
            itemInstrumentList = isorderViewList
                ? itemInstrumentList
                : Object.values(
                      itemInstrumentList?.reduce((acc, curr) => {
                          const productKey =
                              (curr.productCFN || '') +
                              '::' +
                              (curr.salesOrg || '');
                          if (!acc[productKey]) {
                              acc[productKey] = { ...curr };
                          } else {
                              acc[productKey].quantity += curr.quantity;
                          }
                          return acc;
                      }, {})
                  );
            feesOfList = feesOfList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    ...i,
                };
            });

            feesOfList?.map((i) => {
                    feesImplantList.push(i);
            });
            feesImplantList = feesImplantList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    ...i,
                };
            });
            feesInstrumentList = feesInstrumentList?.map((i) => {
                return {
                    productCFN: i.cfn ? i.cfn : i.bom ? i.bom : i.productCFN,
                    quantity: i.quantity ? i.quantity : 1,
                    productKey: i.productKey ? i.productKey : generate_UUID(),
                    ...i,
                };
            });
            feesImplantList =
                isCartScreen ||
                isTemplateScreen ||
                isShippingScreen ||
                isIndependentProductGuide
                    ? feesImplantList
                    : Object.values(
                          feesImplantList?.reduce((acc, curr) => {
                              const productKey =
                                  (curr.productCFN || '') +
                                  '::' +
                                  (curr.salesOrg || '');
                              if (!acc[productKey]) {
                                  acc[productKey] = { ...curr };
                              } else {
                                  acc[productKey].quantity +=
                                      curr.quantity;
                              }
                              return acc;
                          }, {})
                      );
            feesInstrumentList =
                isCartScreen ||
                isTemplateScreen ||
                isShippingScreen ||
                isIndependentProductGuide
                    ? feesInstrumentList
                    : Object.values(
                          feesInstrumentList?.reduce((acc, curr) => {
                              const productKey =
                                  (curr.productCFN || '') +
                                  '::' +
                                  (curr.salesOrg || '');
                              if (!acc[productKey]) {
                                  acc[productKey] = { ...curr };
                              } else {
                                  acc[productKey].quantity +=
                                      curr.quantity;
                              }
                              return acc;
                          }, {})
                      );

            setSetImplant(setImplantList);
            setSetInstrument(setInstrumentList);
            setItemImplant(itemImplantList);
            setItemBundleList(itemBundleList);
            setItemInstrument(itemInstrumentList);
            setFeesImplant(feesImplantList);
            setFeesInstrument(feesInstrumentList);
            dispatch(
                setImplantableAndInstrumentProducts({
                    setImplantProducts: setImplantList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                    setInstrumentProducts: setInstrumentList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                    itemImplantProducts: itemImplantList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                    itemInstrumentProducts: itemInstrumentList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                    itemBundleList: itemBundleList?.sort((a, b) =>
                        a?.productCFN?.localeCompare(b?.productCFN)
                    ),
                    feesOfList: feesOfList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                    feesImplantProducts: feesImplantList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                    feesInstrumentProducts: feesInstrumentList?.sort((a, b) =>
                        a.productCFN.localeCompare(b.productCFN)
                    ),
                })
            );
        }
    }, [products, products.length]);
     return isTemplateScreen || isIndependentProductGuide ? (
        <ListViewCards
            t={t}
            sets={sets}
            setImplant={setImplant}
            setInstrument={setInstrument}
            setSetInstrument={setSetInstrument}
            expandedCard={expandedCard}
            toggleCard={toggleCard}
            handleBundlePopup={handleBundlePopup}
            handleBundleSetItemClick={handleBundleSetItemClick}
            setsQuantityCheck={setsQuantityCheck}
            removeCount={removeCount}
            addCount={addCount}
            handleSetItemClick={handleSetItemClick}
            deleteProduct={deleteProduct}
            isShippingScreen={isShippingScreen}
            isReviewSubmitScreen={isReviewSubmitScreen}
            inventoryShipping={inventoryShipping}
            handleLocationChange={handleLocationChange}
            checkAll={checkAll}
            checked={checked}
            checkSelectAllDisabled={checkSelectAllDisabled}
            selectAllDisabled={selectAllDisabled}
            handleShipAllChange={handleShipAllChange}
            isBatchSelected={isBatchSelected}
            setIsBatchSelected={setIsBatchSelected}
            selectedLocation={selectedLocation}
            isTemplateScreen={isTemplateScreen}
            isIndependentProductGuide={isIndependentProductGuide}
            handleCheckBoxSelection={handleCheckBoxSelection}
            moreTemplates={moreTemplates}
            showDontShip={showDontShip}
            isOrderScreen={isOrderScreen}
            isCartScreen={isCartScreen}
            isFromTemplates={isFromTemplates}
            isEquityTemplate={isEquityTemplate}
            isTemplateDetail={isTemplateDetail}
            items={items}
            itemBundles={itemBundles}
            itemImplant={itemImplant}
            itemInstrument={itemInstrument}
            isConsignmentAdd={isConsignmentAdd}
            isEquityPage={isEquityPage}
            isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
            onBomClick={onBomClick}
            updateProductQuantity={updateProductQuantity}
            fees={fees}
            feesImplant={feesImplant}
            feesInstrument={feesInstrument}
            isEquityScreen={isEquityScreen}
        />
        ) : (
        <MainContainerView
            isOrderScreen={isOrderScreen}
            isConsignmnetAdd={isConsignmnetAdd}
            moreTemplates={moreTemplates}
            isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
            isTemplateDetail={isTemplateDetail}
            sets={sets}
            isOrderScreenListView={isOrderScreenListView}
            isReviewSubmitScreen={isReviewSubmitScreen}
            setImplant={setImplant}
            setInstrument={setInstrument}
            handleBundlePopup={handleBundlePopup}
            handleBundleSetItemClick={handleBundleSetItemClick}
            isSurgery={isSurgery}
            setsQuantityCheck={setsQuantityCheck}
            removeCount={removeCount}
            addCount={addCount}
            handleSetItemClick={handleSetItemClick}
            deleteProduct={deleteProduct}
            isShippingScreen={isShippingScreen}
            inventoryShipping={inventoryShipping}
            handleLocationChange={handleLocationChange}
            isCondensedView={isCondensedView}
            implantShipAll={implantShipAll}
            checkAll={checkAll}
            checked={checked}
            checkSelectAllDisabled={checkSelectAllDisabled}
            selectAllDisabled={selectAllDisabled}
            handleShipAllChange={handleShipAllChange}
            isBatchSelected={isBatchSelected}
            setIsBatchSelected={setIsBatchSelected}
            selectedLocation={selectedLocation}
            isTemplateScreen={isTemplateScreen}
            isIndependentProductGuide={isIndependentProductGuide}
            handleCheckBoxSelection={handleCheckBoxSelection}
            isEquityTemplate={isEquityTemplate}
            isEquityPage={isEquityPage}
            onBomClick={onBomClick}
            showDontShip={showDontShip}
            isCartScreen={isCartScreen}
            isFromTemplates={isFromTemplates}
            instrumentShipAll={instrumentShipAll}
            items={items}
            itemBundles={itemBundles}
            itemImplant={itemImplant}
            isConsignmentAdd={isConsignmentAdd}
            isEquityScreen={isEquityScreen}
            updateProductQuantity={updateProductQuantity}
            itemInstrument={itemInstrument}
            fees={fees}
            feesImplant={feesImplant}
            feesInstrument={feesInstrument}
            products={products}
            overridenDiscount={overridenDiscount}
            nonTissueSummary={nonTissueSummary}
            tissueSummary={tissueSummary}
            setsQuantityCount={setsQuantityCount}
            itemsQuantityCount={itemsQuantityCount}
            isFromConsignmentAdd={isFromConsignmentAdd}
            onEmptyCategory={onEmptyCategory}
        />
    );
};

export default ListViewContainer;
